export default [
  {
    path: '/notebooks/create',
    name: 'notebooks-create',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "project-notebooks" */ '../projects/project/notebooks/NotebookCreate.vue'
      ),
  },
  {
    path: '/notebooks/:notebookId/edit',
    name: 'notebooks-edit-top',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "project-notebooks" */ '../projects/project/notebooks/NotebookEdit.vue'
      ),
  },
  {
    path: '/notebooks/:notebookId?',
    name: 'notebooks-details-top',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "project-notebooks" */ '../projects/project/notebooks/NotebookDetails.vue'
      ),
  },
];
